// Entry point for the esbuild bundle (see package.json build:js).
import "@hotwired/turbo-rails"
import * as Turbo from "@hotwired/turbo"
import "./controllers"

window.Turbo = Turbo
